import { ref } from 'vue';
import { useRoute } from 'vue-router';
import HeaderBrand from '@/components/header/HeaderBrand.vue';
import HeaderUser from '@/components/header/HeaderUser.vue';
import HeaderNotifications from '@/components/header/HeaderNotifications.vue';
import ClientProtocolsViewDialog, { openClientProtocolsViewDialog } from '@/components/header/dialogs/ClientProtocolsViewDialog.vue';
import { store, higherManagementUserIds, performanceUserIds } from '@/stores/store';
import { smAccess } from '@/views/management/stars-magnet/_store';
const headerVisible = ref(false);
export default {
  setup() {
    const route = useRoute();
    return {
      route,
      store,
      higherManagementUserIds,
      performanceUserIds,
      smAccess,
      headerVisible: headerVisible
    };
  },
  components: {
    HeaderNotifications,
    HeaderUser,
    HeaderBrand,
    ClientProtocolsViewDialog
  },
  methods: {
    openClientProtocols() {
      openClientProtocolsViewDialog();
    },
    clientViewToggle() {
      // console.log(this.store.clientView);
      if (this.store.clientView) {
        this.store.setClientView(false);
      } else {
        this.store.setClientView(true);
      }
    },
    headerVisibleToggle(name) {
      if (store.authUser) {
        if (name == 'login' || name == 'login-check' || name == 'logout' || name == 'not-found' || name == 'post' || name == 'client-review' || typeof name == 'string' && (name.startsWith('swell') || name.startsWith('pulse'))) {
          headerVisible.value = false;
        } else {
          headerVisible.value = true;
        }
      }
    },
    reloadPage() {
      window.location.reload();
    }
  },
  watch: {
    "route.name": function (name) {
      this.headerVisibleToggle(name);
    },
    // Stars Magnet menu item: shown to dashboard members only
    "store.currentUser.id": {
      immediate: true,
      handler(id) {
        smAccess.reset();
        if (id && store.currentUser?.user_type === 'staff') smAccess.load();
      }
    }
  }
};